<template>
  <div>
    <v-card v-for="(grado, index) in grados" :key="index">
      <v-toolbar dark color="primary">
        <v-toolbar-title>{{ grado.nombre }}</v-toolbar-title>
      </v-toolbar>
      </v-card-title>
      <v-card-text>
        <div style="background: lightsteelblue;padding: 10px;">
          <p><h3>Asesor</h3></p>
          <v-form action="/" v-model="validarAsesor" lazy-validation>
            <v-layout row wrap>
              <v-flex lg1>
                <v-text-field label="DNI" v-model="grados[index].asesor.dni" v-bind:readonly="grados[index].disabledAsesor" :rules="dniRegla" mask="########"></v-text-field>
              </v-flex>
              <v-flex lg2>
                <v-text-field label="Apellido paterno" v-model="grados[index].asesor.apellidoPaterno" v-bind:readonly="grados[index].disabledAsesor" :rules="requeridoRegla" v-on:keyup="grados[index].asesor.apellidoPaterno = grados[index].asesor.apellidoPaterno.toUpperCase();"></v-text-field>
              </v-flex>
              <v-flex lg2>
                <v-text-field label="Apellido materno" v-model="grados[index].asesor.apellidoMaterno" v-bind:readonly="grados[index].disabledAsesor" :rules="requeridoRegla" v-on:keyup="grados[index].asesor.apellidoMaterno = grados[index].asesor.apellidoMaterno.toUpperCase();"></v-text-field>
              </v-flex>
              <v-flex lg2>
                <v-text-field label="Nombres" v-model="grados[index].asesor.nombres" v-bind:readonly="grados[index].disabledAsesor" :rules="requeridoRegla" v-on:keyup="grados[index].asesor.nombres = grados[index].asesor.nombres.toUpperCase();"></v-text-field>
              </v-flex>
              <v-flex lg2>
                <v-text-field label="Correo" v-model="grados[index].asesor.correo" v-bind:readonly="grados[index].disabledAsesor" :rules="emailRegla" v-on:keyup="grados[index].asesor.correo = grados[index].asesor.correo.toUpperCase();"></v-text-field>
              </v-flex>
              <v-flex lg2>
                <v-text-field label="Teléfono" v-model="grados[index].asesor.telefono" v-bind:readonly="grados[index].disabledAsesor" :rules="requeridoRegla" mask="#########"></v-text-field>
              </v-flex>
              <v-flex lg1>
                <v-btn color="primary" v-if="!grados[index].disabledAsesor" :disabled="!grados[index].validarAsesor" @click="registrarAsesor(grado.id)">Guardar</v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </div>
        <p><h3>Alumnos</h3></p>
        <v-form action="/" v-model="validarAlumno" lazy-validation>
          <table style="width: 100%">
            <thead>
              <tr align="left">
                <th style="padding: 10px 0px 10px 0px">Apellido paterno</th>
                <th>Apellido materno</th>
                <th>Nombres</th>
                <th>DNI</th>
                <th>Correo</th>
                <th>Grado</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="alumno in grado.alumnos">
                <td style="padding: 10px 0px 10px 0px">{{ alumno.fila[1] }}</td>
                <td>{{ alumno.fila[2] }}</td>
                <td>{{ alumno.fila[3] }}</td>
                <td>{{ alumno.fila[4] }}</td>
                <td>{{ alumno.fila[6] }}</td>
                <td>{{ alumno.fila[9] }}</td>
                <td></td>
              </tr>
              <tr>
                <td style="padding: 10px 0px 10px 0px"><v-text-field label="Apellido paterno" v-model="grados[index].alumno.apellidoPaterno" v-bind:readonly="grados[index].disabledRegistro" :rules="requeridoRegla" v-on:keyup="grados[index].alumno.apellidoPaterno = grados[index].alumno.apellidoPaterno.toUpperCase();"></v-text-field></td>
                <td><v-text-field label="Apellido materno" v-model="grados[index].alumno.apellidoMaterno" v-bind:readonly="grados[index].disabledRegistro" :rules="requeridoRegla" v-on:keyup="grados[index].alumno.apellidoMaterno = grados[index].alumno.apellidoMaterno.toUpperCase();"></v-text-field></td>
                <td><v-text-field label="Nombres" v-model="grados[index].alumno.nombres" v-bind:readonly="grados[index].disabledRegistro" :rules="requeridoRegla" v-on:keyup="grados[index].alumno.nombres = grados[index].alumno.nombres.toUpperCase();"></v-text-field></td>
                <td><v-text-field label="DNI" v-model="grados[index].alumno.dni" v-bind:readonly="grados[index].disabledRegistro" :rules="dniRegla" mask="########"></v-text-field></td>
                <td></td>
                <td></td>
                <td><v-btn color="primary" :disabled="!grados[index].validarAlumno" @click="registrarAlumo(grado.id)">Guardar</v-btn></td>
              </tr>
            </tbody>
          </table>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  data: () => ({
    dialog: false,
    disabledRegistro: false,
    disabledAsesor: false,
    validarAlumno: true,
    validarAsesor: true,
    totalRegistros: 0,
    loading: false,
    pagination: {},
    menu: false,
    cierreFecha: null,
    headers: [
      { text: 'Apellido paterno', value: 0 },
      { text: 'Apellido materno', value: 1 },
      { text: 'Nombres', value: 2 },
      { text: 'DNI', value: 3 },
      { text: 'Correo', value: 4 },
      { text: 'Grado', value: 5 },
      { text: 'Actions', align: 'center', value: '', sortable: false }
    ],
    asesor: {
      dni: ''
    },
    grados: {
      '3A': {id: '3A', nombre: 'INICIAL 3 AÑOS', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true},
      '4A': {id: '4A', nombre: 'INICIAL 4 AÑOS', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true},
      '5A': {id: '5A', nombre: 'INICIAL 5 AÑOS', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true},
      '1P': {id: '1P', nombre: '1º PRIMARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true},
      '2P': {id: '2P', nombre: '2º PRIMARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true},
      '3P': {id: '3P', nombre: '3º PRIMARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true},
      '4P': {id: '4P', nombre: '4º PRIMARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true},
      '5P': {id: '5P', nombre: '5º PRIMARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true},
      '6P': {id: '6P', nombre: '6º PRIMARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true},
      '1S': {id: '1S', nombre: '1º SECUNDARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true},
      '2S': {id: '2S', nombre: '2º SECUNDARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true},
      '3S': {id: '3S', nombre: '3º SECUNDARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true},
      '4S': {id: '4S', nombre: '4º SECUNDARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true},
      '5S': {id: '5S', nombre: '5º SECUNDARIA', alumnos: {}, alumno: {}, asesor: {}, disabledAsesor: false, validarAsesor: true, validarAlumno: true}
    },
    datos: [],
    registro: {},
    grado: ''
  }),
  computed: {
    computedCierreFecha () {
      return this.formatoFecha(this.registro.cierreFecha)
    }
  },
  watch: {
    dialog (val) {
      val || this.cerrar()
    },
    'registro.cierreFecha' (val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha)
    }
  },
  created () {
    this.initialize()
    if (this.login === false) {
      this.$router.push('/Ingresar')
    }
    this.apiListaRegistros(0, 0, 1, '3A')
    this.apiListaRegistros(0, 0, 1, '4A')
    this.apiListaRegistros(0, 0, 1, '5A')
    this.apiListaRegistros(0, 0, 1, '1P')
    this.apiListaRegistros(0, 0, 1, '2P')
    this.apiListaRegistros(0, 0, 1, '3P')
    this.apiListaRegistros(0, 0, 1, '4P')
    this.apiListaRegistros(0, 0, 1, '5P')
    this.apiListaRegistros(0, 0, 1, '6P')
    this.apiListaRegistros(0, 0, 1, '1S')
    this.apiListaRegistros(0, 0, 1, '2S')
    this.apiListaRegistros(0, 0, 1, '3S')
    this.apiListaRegistros(0, 0, 1, '4S')
    this.apiListaRegistros(0, 0, 1, '5S')
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    apiListaRegistros (idx, ord, pagina, grado) {
      var solicitudApi = this.crearSolicitud()
      if (this.datos.pagina === undefined) {
        pagina = 0
      }
      this.loading = true
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina,
        grado: grado
      }
      solicitudApi.datos = datos
      const myRequest = new Request(`${process.env.API}inicio.php?mod=ficha&accion=listar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$router.push('Ingresar')
          } else {
            this.grados[grado].alumnos = datos.d.data
            this.totalRegistros = this.datos.registros
            this.loading = false
            this.grados[grado].disabledAsesor = false
            if (1 in datos.d.asesor) {
              this.grados[grado].asesor.dni = datos.d.asesor[4]
              this.grados[grado].asesor.apellidoPaterno = datos.d.asesor[1]
              this.grados[grado].asesor.apellidoMaterno = datos.d.asesor[2]
              this.grados[grado].asesor.nombres = datos.d.asesor[3]
              this.grados[grado].asesor.correo = datos.d.asesor[6]
              this.grados[grado].asesor.telefono = datos.d.asesor[5]
              this.grados[grado].disabledAsesor = true
            }
          }
        })
    },
    setTotal: function (total) {
      this.registro.comprobanteTotal = total
    },
    registrarAlumo (grado) {
      var solicitudApi = this.crearSolicitud()
      this.grados[grado].alumno.grado = grado
      this.grados[grado].alumno.tipo = 'D'
      this.grados[grado].alumno.telefono = ''
      solicitudApi.datos = this.grados[grado].alumno
      const myRequest = new Request(`${process.env.API}inicio.php?mod=ficha&accion=guardar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.e === 1) {
            this.grados[grado].alumno = {
              apellidoPaterno: '',
              apellidoMaterno: '',
              nombres: '',
              dni: '',
              telefono: '',
              correo: ''
            }
            this.verAlumnos(grado)
          } else {
            alert(datos.m)
          }
        })
    },
    registrarAsesor (grado) {
      var solicitudApi = this.crearSolicitud()
      this.grados[grado].asesor.grado = grado
      this.grados[grado].asesor.tipo = 'A'
      solicitudApi.datos = this.grados[grado].asesor
      const myRequest = new Request(`${process.env.API}inicio.php?mod=ficha&accion=guardar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.e === 1) {
            this.grados[grado].disabledAsesor = true
          } else {
            alert(datos.m)
          }
        })
    },
    verRegistro (item) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = []
      const myRequest = new Request(`${process.env.API}ventas/cierre/ver/id/` + item.fila[0], {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.registro = datos.d
            this.productosDetalle = {}
            if (item.fila[0] !== 0) {
              this.disabledRegistro = true
            } else {
              this.disabledRegistro = false
            }
            this.dialog = true
          }
        })
    },
    nuevoRegistro () {
      this.verRegistro({fila: [0]})
    },
    cerrar () {
      this.dialog = false
      setTimeout(() => {
      }, 300)
    },
    verAlumnos (grado) {
      this.apiListaRegistros(0, 0, 1, grado)
    },
    imprimirCredencial () {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {datos: this.datos.data}
      const myRequest = new Request(`${process.env.API}credencial.php`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.blob())
        .then(fileBlob => {
          var newBlob = new Blob([fileBlob], {type: 'application/pdf'})
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
          }
          const data = window.URL.createObjectURL(newBlob)
          var link = document.createElement('a')
          link.href = data
          link.target = '_blank'
          link.click()
        })
    }
  }
}
</script>

<style>
input[type="text"] {
  font-size: 13px;
}
.v-text-field {
  padding: 0px 2px;
}
.v-btn {
  min-width: 68px;
  font-size: 12px;
  padding: 0 7px
}
</style>



// WEBPACK FOOTER //
// src/components/FichaInscripcion.vue